export default "__VITE_ASSET__Dy$wNGjA__"